import COLORS from 'lib/constants/colors';
import { CSSProperties, FC } from 'react';
import styled from 'styled-components';

interface Props {
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  style?: CSSProperties;
  type?: 'submit' | 'reset' | 'button';
  className?: string;
  id?: string;
  pink?: boolean;
  buttonRef?: React.Ref<HTMLButtonElement>;
}

const StyledButton = styled.button`
  font-size: 16px;
  border: none;
  padding: 0px;
  background: transparent;
  /* font-family: 'Poppins', sans-serif; */
  text-decoration: underline;
`;

const LinkButton: FC<Props> = ({
  type = 'button',
  onClick,
  style,
  children,
  className,
  pink = false,
  buttonRef,
  ...props
}) => (
  <StyledButton
    {...props}
    type={type}
    style={{ ...style, color: pink ? COLORS.pink : COLORS.aqua }}
    onClick={onClick}
    className={className}
    ref={buttonRef}
  >
    {children}
  </StyledButton>
);

export default LinkButton;
